"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagerPageMigration = void 0;
const react_1 = __importStar(require("react"));
const Button_1 = __importDefault(require("react-bootstrap/Button"));
const Container_1 = __importDefault(require("react-bootstrap/Container"));
const configContext_1 = require("../../context/configContext");
const environment_1 = require("../../environment");
const useFirestore_1 = require("../../utils/useFirestore");
const Spinner_1 = require("../spinner/Spinner");
const ManagerPageMigration = (props) => {
    const config = (0, configContext_1.useConfig)();
    const firestore = (0, useFirestore_1.useFirestore)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    async function migrate() {
        setIsLoading(true);
        // const bookingSnapshot = await getDocs(
        //   query(
        //     collection(firestore, "bookings"),
        //     where("tenantId", "==", "hirschengraben"),
        //     where("resourceId", "==", "aihub"),
        //     where("resourceItem.title", "==", "Blue Saloon"),
        //   )
        // );
        // console.log(bookingSnapshot.docs.length);
        // bookingSnapshot.docs.forEach((doc) => {
        //   console.log(doc.id);
        //   updateDoc(doc.ref, { "resourceItem.title": "AI-Hub" });
        // });
        setIsLoading(false);
    }
    return (react_1.default.createElement(Container_1.default, { className: "mt-5" },
        react_1.default.createElement("h1", null, "Migration"),
        react_1.default.createElement("p", null,
            "Tenant: ",
            config.tenantId,
            react_1.default.createElement("br", null),
            react_1.default.createElement("strong", null,
                "Env: ",
                (0, environment_1.getEnv)().envName)),
        react_1.default.createElement(Button_1.default, { onClick: migrate, disabled: isLoading }, isLoading ? react_1.default.createElement(Spinner_1.Spinner, null) : react_1.default.createElement(react_1.default.Fragment, null, "Migrate"))));
};
exports.ManagerPageMigration = ManagerPageMigration;
